import * as React from "react";
import { SVGProps } from "react";

const Fetch = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25" {...props}>
    <path
      fill="#202944"
      d="M0 0v25h24.6V0Zm8.6 2.9h2.3v2.4H8.6Zm-5.8 0h2.4v2.4H2.8Zm2.3 5.8v2.4H2.7V8.7Zm-.6 13.2h-1V21h.9v.9Zm.7-4.8H2.8v-2.3h2.4Zm5.1 4.8h-.9V21h.9Zm0-5.6h-.9v-.9h.9Zm.7-5.1H8.6V8.8H11Zm5.1 10.7h-.9V21h.9Zm0-5.6h-.9v-.9h.9Zm0-5.9h-.9v-.9h.9Zm.8-5.1h-2.4V2.9h2.4ZM22 21.9h-.9V21h.9Zm0-5.6h-.9v-.9h.9Zm0-5.9h-.9v-.9h.9Zm0-5.8h-.9v-.9h.9Z"
    />
  </svg>
);

export default Fetch;
